import { render, staticRenderFns } from "./StatsInstanceSelector.vue?vue&type=template&id=013ae870&"
import script from "./StatsInstanceSelector.vue?vue&type=script&lang=js&"
export * from "./StatsInstanceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports